export default __webpack_public_path__ + "static/media/swooshWhite.bb994b56.svg";